import { getBlazeAdmin } from '@blaze-cms/admin';
import buildConfig from '../blaze.config';
import './styles/main.scss';

const app = getBlazeAdmin({ buildConfig });
app.render();
